// extracted by mini-css-extract-plugin
module.exports = {"Root":"BasicLoader_Root__xx5fs","Dark":"BasicLoader_Dark__CiFHX","Loader":"BasicLoader_Loader__bgSS7","rotation":"BasicLoader_rotation__qNk94"};